import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformBenefits = () => {
  const benefits = [
    {
      icon: 'Search',
      title: 'Vergelijk Providers',
      description: 'Vind de beste duurzaamheidsoplossingen voor uw woning uit duizenden gecertificeerde providers.',
      color: 'text-primary'
    },
    {
      icon: 'Shield',
      title: 'Geverifieerde Partners',
      description: 'Alle providers zijn gescreend en gecertificeerd volgens Nederlandse kwaliteitsnormen.',
      color: 'text-success'
    },
    {
      icon: 'Calculator',
      title: 'Gratis Offertes',
      description: 'Ontvang meerder offertes en vergelijk prijzen zonder verborgen kosten.',
      color: 'text-secondary'
    },
    {
      icon: 'Award',
      title: 'Subsidie Ondersteuning',
      description: 'Krijg hulp bij het aanvragen van Nederlandse subsidies en belastingvoordelen.',
      color: 'text-accent'
    },
    {
      icon: 'Users',
      title: 'Klantbeoordelingen',
      description: 'Lees echte reviews van Nederlandse huiseigenaren over hun ervaringen.',
      color: 'text-warning'
    },
    {
      icon: 'Headphones',
      title: '24/7 Ondersteuning',
      description: 'Nederlandse klantenservice die u begeleidt van offerte tot installatie.',
      color: 'text-error'
    }
  ];

  const stats = [
    { label: 'Tevreden Klanten', value: '15.000+', icon: 'Users' },
    { label: 'Gecertificeerde Providers', value: '500+', icon: 'Building' },
    { label: 'Gemiddelde Besparing', value: '€1.200', icon: 'TrendingDown' },
    { label: 'Projecten Voltooid', value: '25.000+', icon: 'CheckCircle' }
  ];

  return (
    <div className="space-y-6">
      {/* Main Benefits */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
        <div className="text-center mb-6">
          <h3 className="text-xl font-heading font-semibold text-foreground mb-2">
            Waarom Verduurzaamwijzer?
          </h3>
          <p className="text-sm font-body text-muted-foreground">
            Nederland's grootste platform voor duurzame woningoplossingen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center">
                  <Icon name={benefit?.icon} size={20} className={benefit?.color} />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-heading font-semibold text-foreground mb-2">
                  {benefit?.title}
                </h4>
                <p className="text-xs font-body text-muted-foreground leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-lg p-6 border border-border">
        <div className="text-center mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
            Vertrouwd door Duizenden Nederlanders
          </h3>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 bg-card rounded-full flex items-center justify-center mx-auto mb-2 shadow-elevation-1">
                <Icon name={stat?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="text-lg font-heading font-bold text-foreground">
                {stat?.value}
              </div>
              <div className="text-xs font-body text-muted-foreground">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Seasonal Tips */}
      <div className="bg-card rounded-lg shadow-elevation-1 p-6 border border-border">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-warning/10 rounded-full flex items-center justify-center">
              <Icon name="Lightbulb" size={18} color="var(--color-warning)" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-heading font-semibold text-foreground mb-2">
              💡 Seizoenstip - Augustus 2025
            </h4>
            <p className="text-xs font-body text-muted-foreground mb-3">
              Nu is het perfecte moment om zonnepanelen te installeren! Profiteer van de zomermaanden voor optimale opbrengst en bereid u voor op de winter.
            </p>
            <div className="flex items-center space-x-4 text-xs font-caption">
              <span className="flex items-center space-x-1 text-success">
                <Icon name="Sun" size={12} />
                <span>Hoge zonne-opbrengst</span>
              </span>
              <span className="flex items-center space-x-1 text-primary">
                <Icon name="Euro" size={12} />
                <span>Subsidies beschikbaar</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformBenefits;